import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import { Window } from "@progress/kendo-react-dialogs";
import Images from "../../Assets/Images";
import "../../Styles/HeatMap.scss";
import { toastr } from "react-redux-toastr";
import Api from "../../Services/Api";
import { Dropdown } from "react-bootstrap";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Popup } from "@progress/kendo-react-popup";
import { CircularProgress } from "@material-ui/core";
import * as moment from "moment";
import StatusComponent from "../Tenant/Component/StatusComponent";
import AddToCart from "../Tenant/AddToCart";
import ImpactEditComponent from "../Tenant/Component/ImpactEditComponent";
import { exportImage, drawDOM, exportPDF } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import ViewActionRiskDataset from "./ViewActionRiskDataset";
import TextNarrative from "./TextNarrative";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import ExportHeatmapViewActionRiskDataset from "./ExportHeatmapViewActionRiskDataset";
import SkeletonReport from "./SkeletonReport";
import PrePostComponenant from "../Tenant/Component/PrePostComponenant";
import TextNarrativeExport from "./TextNarrativeExport";
import ReportUpdate from "./ReportUpdate";

class HeatMapChartContainer extends Component {
  _pdfExportComponent;
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      visibleDataset: false,
      riskList: [],
      skip: 0,
      take: 10,
      emailId: "",
      message: "",
      projectHomeFlag: false,
      openPdfTitlePopup: false,
      // widgettitle:this.props.widgettitle,
      isReportLoaded: false,
      chartData: {},
      HeatMapConfigDataOpportunity: [],
      HeatMapConfigDataThreat: [],
      dynamicHeatmapProbabilityRange: [],
    };
    this._pdfExportComponent = React.createRef();
  }
  componentDidMount = () => {
    if (
      this.props.dashboardId &&
      this.props.reportId &&
      !this.props.chartInputs
    ) {
      this.fetchReportsByPagination(
        this.props.dashboardId,
        this.props.reportId
      );
    } else {
      this.setState({
        chartData: this.props.chartInputs ? this.props.chartInputs : {},
        isReportLoaded: true,
      });
    }
  };
  fetchReportsByPagination = async (dashboardId, reportId) => {
    try {
      var request = {
        CreatedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
        DashBoardId: parseInt(dashboardId),
        WidgetListIds: [reportId],
      };
      let response = await Api.getReportsByDashboardID(request);
      if (response.status === 200 && response.chartData) {
        this.setState({
          chartData: response.chartData[0],
          isReportLoaded: true,
        });

        this.props.updateResponse(reportId, response.chartData[0]);
      } else {
        this.setState({
          chartData: {},
          isReportLoaded: true,
        });
      }
    } catch (error) {
      console.error(error);
      this.setState({
        chartData: {},
        isReportLoaded: true,
      });
    }
  };
  getMatrixColorCodes = async () => {
    try {
      // var req = {
      //   WorkstreamId: 0,
      // };
      let response = await Api.MatrixColor();
      if (response.status === 200) {
        // normal,opportunity
        let normal_opp = response.matrixColor.find(
          (item) => item.riskType === "opportunity"
        );
        let opp_colorJsonData = JSON.parse(normal_opp.colorJsonData);

        //  normal,threat
        let normal_threat = response.matrixColor.find(
          (item) => item.riskType === "threat"
        );
        let threat_colorJsonData = JSON.parse(normal_threat.colorJsonData);
        this.setState({

          HeatMapConfigDataThreat: threat_colorJsonData,
          HeatMapConfigDataOpportunity: opp_colorJsonData,

          heatMapCount: response.heatmapCount,
          dynamicHeatmapProbabilityRange:
            response.dynamicHeatmapProbabilityRange,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  componentDidUpdate = () => {
    return false;
  };

  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };

  toggleDialog = async (riskIds) => {
    if (riskIds && riskIds.length > 0) {
      this.getMatrixColorCodes();
      await this.getRiskListByOrgUnitIds(riskIds);
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  };

  closeToggleClose = () => {
    this.setState({
      visible: false,
    });
  };

  getRiskListByOrgUnitIds = async (idList) => {
    try {
      var request = {
        riskIds: idList,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.getRiskByRiskIds(request);
      if (response.status == 200) {
        response.riskRegister.map((riskReg) => {
          if (riskReg.proximityDate) {
            riskReg.proximityDate = new Date(riskReg.proximityDate);
          }
          if (riskReg.closedDate) {
            riskReg.closedDate = new Date(riskReg.closedDate);
          } else {
            riskReg.closedDate = null;
          }
          if (riskReg.updatedDate) {
            var time = moment(riskReg.updatedDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let updatedDate = time;
            riskReg.updatedDate = riskReg.updatedDate
              ? new Date(updatedDate)
              : "";
          } else {
            riskReg.updatedDate = null;
          }
          if (riskReg.createdDate) {
            var time = moment(riskReg.createdDate).toDate();
            time.setHours(0);
            time.setMinutes(0);
            time.setSeconds(0);
            time.setMilliseconds(0);
            let createdDate = time;
            riskReg.createdDate = riskReg.createdDate
              ? new Date(createdDate)
              : "";
          } else {
            riskReg.createdDate = null;
          }
        });
        let impactMaster = [];
        if (response.riskRegister && response.riskRegister.length > 0) {
          impactMaster = response.riskRegister[0].impactResponse;
        }
        this.setState({ ...this.state, impactMaster: impactMaster });
        // await this.constructImpactApprovalData(response.riskRegister);
        await this.createDynamicCols(response.riskRegister);
        let riskData = response.riskRegister.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        );
        this.setState({ ...this.state, riskList: riskData, loader: false });
      } else {
        this.setState({
          ...this.state,
          riskList: [],
          riskTemp: [],
          loader: false,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  numericCellEdit = (dataItem, field, riskData) => { };

  createDynamicCols = async (products) => {
    let impactColumn = [];

    products.map((res, i) => {
      if (res.impactResponse) {
        res.impactResponse.map((item, j) => {
          if (impactColumn.length > 0) {
            if (!impactColumn.includes(item.name + "_" + item.type)) {
              impactColumn.push(item.name + "_" + item.type);
            }
          } else {
            impactColumn.push(item.name + "_" + item.type);
          }
        });
      }
    });
    // impactColumn.sort();
    // impactColumn.reverse();
    if (impactColumn.length > 0) {
      products.map((res) => {
        impactColumn.map((col) => {
          let temp = res.impactResponse.filter(
            (item) => item.name + "_" + item.type === col
          );
          if (temp.length > 0) {
            res[col] =
              temp[0].type == "Post" ? temp[0].postImpactValue : temp[0].value;
          } else {
            res[col] = undefined;
          }
        });
      });
    }

    let columnsToShow = [];
    if (impactColumn.length > 0) {
      columnsToShow = impactColumn.map((item) => (
        <Column
          field={item}
          title={this.getImpactUnit(item)}
          width="100px"
          editable={false}
          cell={(props) => (
            <ImpactEditComponent {...props} onEditCell={this.onEditCell} />
          )}
          filter={"numeric"}
        />
      ));
    }
    this.setState({ ...this.state, impactColumns: columnsToShow });
  };

  getImpactUnit = (impact) => {
    var impactTemp = this.state.impactMaster.find(
      (item) => item.name + "_" + item.type === impact
    );
    var res = impact;
    if (impactTemp && impactTemp.name) {
      res =
        impactTemp.name +
        " / " +
        impactTemp.units +
        " (" +
        impactTemp.type +
        ")";
    }
    return res;
  };

  constructImpactApprovalData = async (riskArray) => {
    riskArray.map((risk) => {
      risk.impactResponse.map((impact) => {
        if (risk.isOpportunity && risk.isOpportunity == "Threat") {
          var totalvalue = this.countApprovalValue(
            impact.name,
            risk.mitigationResps,
            risk.isOpportunity
          );
          let approvedValue = Math.max(0, impact.value - totalvalue);
          impact["value"] = impact.value + "_" + approvedValue;
        } else if (risk.isOpportunity && risk.isOpportunity == "Opportunity") {
          var totalvalue = this.countApprovalValue(
            impact.name,
            risk.mitigationResps,
            risk.isOpportunity
          );
          //let approvedValue = Math.abs(impact.value) - Math.abs(totalvalue);
          if (totalvalue > Math.abs(impact.value)) {
            totalvalue = impact.value;
          }
          impact["value"] = impact.value + "_" + -Math.abs(totalvalue);
        }
      });
    });

    this.setState({ ...this.state, data: riskArray });
  };

  countApprovalValue = (name, mitigationArray, flag) => {
    var totalvalue = 0;
    mitigationArray.map((mitigation) => {
      if (mitigation.approved) {
        var impactObj = mitigation.impactResponse.filter(
          (item) => item.name == name
        );
        if (impactObj.length > 0) {
          var temp = impactObj[0];
          totalvalue =
            flag == "Threat"
              ? totalvalue + temp.value
              : totalvalue - temp.value;
        }
      }
    });
    return totalvalue;
  };

  openWidgetDeletePopup = () => {
    if (!this.props.isFreezeDS) {
      this.setState({
        ...this.state,
        openDeleteModelFlag: true,
      });
    }
  };
  closeWidgetDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlag: false,
    });
  };

  removeWidget = async (data) => {
    try {
      const requestParams = {
        DeletedBy: data.widgetId || this.props.reportId,
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.deleteWidget(requestParams);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
        this.closeWidgetDeletePopup();
        this.props.selectedDB(true);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  changeLineChartWidth = (widgetId) => {
    this.props.changeLineChartWidth(widgetId);
  };
  editWidget = (data) => {
    if (data.isActionWidget) {
      this.refs.childWidget.editWidgetdOpen("MITI", data);
    } else {
      this.refs.childWidget.editWidgetdOpen("RISK", data);
    }
  };

  selectedDB = (data) => {
    this.props.selectedDB(data);
  };
  moveToHome = async (data) => {
    try {
      var req = {
        Enable: true,
        WidgetId: data.widgetId,
        CreatedBY: parseInt(secureLocalStorage.getItem("loginUserId")),
        CreatedDate: new Date(),
      };
      this.setState({ ...this.state, loader: true });
      let response = await Api.WidgetHome(req);
      if (response.status === 200) {
        this.setState({ ...this.state, loader: false });
        toastr.success(response.message);
      } else {
        this.setState({ ...this.state, loader: false });
        toastr.error(response.message);
      }
    } catch (error) {
      console.error(error);
      this.setState({ ...this.state, loader: false });
    }
  };

  sendMail = async (dataURL, widgetId) => {
    this.setState({ ...this.state, loader: true });
    const CreatedDate = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");
    let widgetName = this.state.chartData
      ? this.state.chartData.widgetName
      : "Heatmap";
    var file = this.dataURLtoFile(dataURL, widgetName + ".pdf");
    var fd = new FormData(document.forms[0]);
    fd.append("file", file);
    fd.append("mailId", this.state.emailId);
    fd.append("message", this.state.message);
    fd.append("widgetId", widgetId);
    fd.append("createdby", parseInt(secureLocalStorage.getItem("loginUserId")));
    fd.append("CreatedDate", CreatedDate);
    fd.append("name", secureLocalStorage.getItem("userName"));
    fd.append("TenantKey", secureLocalStorage.getItem("tenantKey"));
    let response = await Api.shareWidgetToUser(fd);
    if (response.status === 200) {
      this.setState({ ...this.state, loader: false, emailId: "", message: "" });
      toastr.success(response.message);
    } else {
      this.setState({ ...this.state, loader: false });
      toastr.error(response.message);
    }
  };
  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(","),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }

  refreshDashboard = (flag) => {
    this.props.refreshDashboard(flag);
  };

  onEditCell = () => { };
  openAddToCart(data) {
    this.setState({
      showAddToCart: true,
      cartViewDetails: data,
      cartViewType: "Widget",
    });
  }
  closeAddToCart() {
    this.setState({ showAddToCart: false });
  }
  pdfTitlePopupClose = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        openPdfTitlePopup: false,
        title: "",
        isHidden: false,
      });
    }, 1000);
  };
  pdfTitlePopupOpen = () => {
    this.setState({
      ...this.state,
      openPdfTitlePopup: true,
      isHidden: true,
    });
  };
  onImageExportClick = () => {
    const { chartData } = this.state;
    const widgetName = chartData?.widgetName || "Heatmap";
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    const chartId = chartData?.widgetId;
    const htmlId = "#c" + chartId;
    const originalElement = document.querySelector(htmlId);

    // Clone the element to avoid mutations
    const gridElement = originalElement.cloneNode(true);
    gridElement.id = "export_" + chartId; // New unique ID for the cloned export
    // ✅ Hide it off-screen instead of showing at bottom
    gridElement.style.position = "absolute";
    gridElement.style.top = "-9999px";
    gridElement.style.left = "-9999px";
    // gridElement.style.visibility = "hidden";

    document.body.appendChild(gridElement);

    // ========= Narrative Setup =========
    const narrativeElement = gridElement.querySelector(".textnarrativeexport");
    if (narrativeElement) {
      narrativeElement.style.display = "block";
      const pTag = narrativeElement.querySelector("p");
      if (pTag) {
        pTag.textContent = chartData?.textNarrative || "";
      }
    }

    // ========= Temporary Styling =========
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-export-style", chartId);
    styleTag.innerHTML = `
    #export_${chartId} {
      background: white !important;
      font-family: "Barlow", sans-serif !important;
    }

    #export_${chartId} * {
      color: black !important;
      font-size: 12px !important;
      font-family: "Barlow", sans-serif !important;
    }
 /* Specific targeting for the dataset header which appears to have a black background */
      #export_${chartId} .wgHeader {
        background-color: white !important;
        color: black !important;
        border: none !important;
        margin: 0 !important;
        padding: 10px !important;
      }
      
      #export_${chartId} .wgHeader h4 {
        background-color: white !important;
        color: black !important;
        margin: 0 !important;
      }
    #export_${chartId} .textnarrativeexport {
  display: block !important;
  color: black !important;
  width: 100% !important;
  max-width: 1000px !important; /* Constrain width */
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  padding: 10px !important;
  box-sizing: border-box !important;
}

#export_${chartId} .textnarrativeexport p {
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  font-size: 12px !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.4;
  width: 100% !important;
  max-width: 100% !important;
}

    #export_${chartId} .wgHeader h4 {
      font-size: 12px !important;
      font-weight: normal !important;
      color: black !important;
    }

    #export_${chartId} .heatmapHeader {
      background-color: white !important;
    }
  `;
    document.head.appendChild(styleTag);

    // Force layout refresh
    gridElement.style.display = "none";
    void gridElement.offsetHeight;
    gridElement.style.display = "";

    // ========= Export to PDF =========
    setTimeout(async () => {
      try {
        const group = await drawDOM(gridElement, {
          title: chartData?.title + " " + CreatedDate,
          paperSize: "auto",
          margin: "1cm",
          scale: 1,
          forcePageBreak: ".pdf-page-break",
          background: "#ffffff",
        });

        const dataURI = await exportImage(group, {
          background: "#ffffff",
        });

        saveAs(dataURI, `${widgetName}.png`);
      } catch (error) {
        console.error("PDF export error:", error);
      } finally {
        // Clean up
        const oldStyle = document.querySelector(`style[data-export-style="${chartId}"]`);
        if (oldStyle) document.head.removeChild(oldStyle);
        document.body.removeChild(gridElement);

        if (narrativeElement) {
          narrativeElement.style.display = "none";
          const pTag = narrativeElement.querySelector("p");
          if (pTag) pTag.textContent = "";
        }
      }
    }, 1000);
  };
  onPDFExportClick = (flag) => {
    const { chartData } = this.state;
    const widgetName = chartData?.widgetName || "Heatmap";
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    const chartId = chartData?.widgetId;
    const htmlId = "#c" + chartId;
    const originalElement = document.querySelector(htmlId);

    // Clone the element to avoid mutations
    const gridElement = originalElement.cloneNode(true);
    gridElement.id = "export_" + chartId; // New unique ID for the cloned export
    // ✅ Hide it off-screen instead of showing at bottom
    gridElement.style.position = "absolute";
    gridElement.style.top = "-9999px";
    gridElement.style.left = "-9999px";
    // gridElement.style.visibility = "hidden";

    document.body.appendChild(gridElement);

    // ========= Narrative Setup =========
    const narrativeElement = gridElement.querySelector(".textnarrativeexport");
    if (narrativeElement) {
      narrativeElement.style.display = "block";
      const pTag = narrativeElement.querySelector("p");
      if (pTag) {
        pTag.textContent = chartData?.textNarrative || "";
      }
    }

    // ========= Temporary Styling =========
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-export-style", chartId);
    styleTag.innerHTML = `
    #export_${chartId} {
      background: white !important;
      font-family: "Barlow", sans-serif !important;
    }

    #export_${chartId} * {
      color: black !important;
      font-size: 12px !important;
      font-family: "Barlow", sans-serif !important;
    }
 /* Specific targeting for the dataset header which appears to have a black background */
      #export_${chartId} .wgHeader {
        background-color: white !important;
        color: black !important;
        border: none !important;
        margin: 0 !important;
        padding: 10px !important;
      }
      
      #export_${chartId} .wgHeader h4 {
        background-color: white !important;
        color: black !important;
        margin: 0 !important;
      }
    #export_${chartId} .textnarrativeexport {
  display: block !important;
  color: black !important;
  width: 100% !important;
  max-width: 1000px !important; /* Constrain width */
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  padding: 10px !important;
  box-sizing: border-box !important;
}

#export_${chartId} .textnarrativeexport p {
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  font-size: 12px !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1.4;
  width: 100% !important;
  max-width: 100% !important;
}
    #export_${chartId} .heatmap_timestamp{
font-size: 16px !important;
      font-weight: normal !important;
      color: black !important;
    }
    #export_${chartId} .wgHeader h4 {
      font-size: 12px !important;
      font-weight: normal !important;
      color: black !important;
    }

    #export_${chartId} .heatmapHeader {
      background-color: white !important;
    }
  `;
    document.head.appendChild(styleTag);

    // Force layout refresh
    gridElement.style.display = "none";
    void gridElement.offsetHeight;
    gridElement.style.display = "";

    // ========= Export to PDF =========
    setTimeout(async () => {
      try {
        const group = await drawDOM(gridElement, {
          title: chartData?.title + " " + CreatedDate,
          paperSize: "auto",
          margin: "1cm",
          scale: 1,
          forcePageBreak: ".pdf-page-break",
          background: "#ffffff",
        });

        const dataURI = await exportPDF(group, {
          background: "#ffffff",
        });
if (flag === "MAIL") {
          this.sendMail(dataURI, chartId);
        }else{
          saveAs(dataURI, widgetName + ".pdf");
        }
        // saveAs(dataURI, `${widgetName}.pdf`);
      } catch (error) {
        console.error("PDF export error:", error);
      } finally {
        // Clean up
        const oldStyle = document.querySelector(`style[data-export-style="${chartId}"]`);
        if (oldStyle) document.head.removeChild(oldStyle);
        document.body.removeChild(gridElement);

        if (narrativeElement) {
          narrativeElement.style.display = "none";
          const pTag = narrativeElement.querySelector("p");
          if (pTag) pTag.textContent = "";
        }
      }
    }, 1000);

  };


  exportPDFWithMethod = () => {
    let element = this._pdfExportComponent.current || document.body;
    savePDF(element, {
      paperSize: "auto",
      margin: 40,
      fileName: `Report for ${new Date().getFullYear()}`,
    });
    this.pdfTitlePopupClose();
  };

  shareFile = (widgetId) => {
    const CreatedDate = moment(new Date()).format("DD-MMM-yyyy");
    let chartId = this.state.chartData.widgetId;
    let htmlId = "#c" + chartId;
    let gridElement = document.querySelector(htmlId);

    drawDOM(gridElement, {
      //  paperSize: "A4",
      landscape: true,
      title: this.state.title + " " + CreatedDate,
    })
      .then((group) => {
        return exportPDF(group);
      })
      .then((dataURI) => {
        this.sendMail(dataURI, widgetId);
        // console.log(dataUri.split(";base64,")[1]);
      });
  };
  ViewDataSet = () => {
    this.setState({
      visibleDataset: true,
    });
  };
  closeVisibleDataset = () => {
    this.setState({
      visibleDataset: false,
    });
  };
  refreshTextNarative = (text, widgetId) => {
    this.props.refreshTextNarative &&
      this.props.refreshTextNarative(text, widgetId);
  };
  getBackgroundColor = (index1, index2) => {
    const chartData = this.state.chartData ? this.state.chartData : {};
    const colorsObject = chartData?.matrixColor?.colorJsonData
      ? JSON.parse(chartData.matrixColor.colorJsonData)
      : [];
    let colorCode = { "background-color": "" };
    let arr1 = colorsObject?.map((item, ind1) => {
      item["row"] = item?.row?.map((cols, ind2) => {
        if (ind1 === index1 && ind2 === index2) {
          colorCode = { "background-color": cols.colorCode };
        }
        return cols;
      });
      return item;
    });
    return colorCode;
  };
  editWidgetOpen = (data) => {
    this.refs.childUpdateWidget.editWidgetdOpen(data);
  };
  updateChartData = async (data) => {
    await this.fetchReportsByPagination(data.dashboardId, data.widgetId);
    this.refs.childUpdateWidget.updateReportPopupClose();
  };
  render() {
    const isPrime = secureLocalStorage.getItem("isPrime") == true ? true : false;
    const chartData = this.state.chartData ? this.state.chartData : {};
    const userId = parseInt(secureLocalStorage.getItem("loginUserId"));
    const CreatedDate = moment(chartData.createdDate).format("DD-MMM-yyyy");
    const series = chartData.series ? chartData.series : [];
    const series1 = chartData.series1 ? chartData.series1 : [];
    const series2 = chartData.series2 ? chartData.series2 : [];
    const dynamicHeatmapProbabilityRange =
      chartData?.dynamicHeatmapProbabilityRange || [];
    const probabilityRange = [...dynamicHeatmapProbabilityRange]?.reverse();
    if (!this.state.isReportLoaded) {
      return <SkeletonReport />;
    } else if (!chartData.series || !chartData.series1) {
      return (
        <div>
          <ul className="WidgetActions">
            {this.props.isTenentAdmin ||
              chartData.createdBy == userId ||
              (this.props.selectedDashboard &&
                this.props.selectedDashboard.createdBy == userId)
              ? !this.props.isFreezeDS && (
                <li onClick={this.openWidgetDeletePopup}>
                  <a className="bgRed">
                    <img src={Images.TRASH} alt="Trash" width="13" />
                  </a>
                </li>
              )
              : ""}
          </ul>
          <h4 className="wgTitle">No Data Found</h4>
          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>
        </div>
      );
    } else {
      return (
        <div className="heatMapChartCont">
          {this.state.visible && (
            <Window
              title={"Heatmap Risks"}
              onClose={this.closeToggleClose}
              className="statusWindow"
              initialLeft={350}
              initialTop={200}
              initialWidth={1000}
              initialHeight={200}
            >
              <div className="tblCont dataGrids">
                <Grid
                  data={this.state.riskList.slice(
                    this.state.skip,
                    this.state.take + this.state.skip
                  )}
                  sortable={true}
                  pageable={true}
                  reorderable
                  resizable
                  skip={this.state.skip}
                  take={this.state.take}
                  total={this.state.riskList.length}
                  onPageChange={this.pageChange}
                >
                  <Column
                    field="organizationUnitName"
                    title="Workstream"
                    width="80px"
                  />

                  <Column field="number" title="Risk Number" width="100px" />
                  <Column field="riskTitle" title="Risk Title" width="80px" />
                  <Column
                    field="isOpportunity"
                    title="T/O"
                    width="150px"
                    cell={(props) =>
                      props.dataItem.isOpportunity === "Threat" ? (
                        <td>{props.dataItem.isOpportunity}</td>
                      ) : (
                        <td>
                          <span className="turquoiseBlue">
                            {props.dataItem.isOpportunity}
                          </span>
                        </td>
                      )
                    }
                  />
                  <Column field="name" title="Risk Description" width="80px" />
                  <Column
                    field="riskTypeNames"
                    title="Risk Type"
                    width="150px"
                  />
                  {/* 
                  <Column
                    field="mitigationCount"
                    title="Action Count"
                    width="80px"
                  /> */}
                  <Column field="cause" title="Cause" width="100px" />
                  <Column
                    field="existingControl"
                    title="Existing Control"
                    width="100px"
                  />
                  <Column
                    field="frequency"
                    title="Pre-Probability (%)"
                    width="80px"
                  />
                  <Column
                    field="currentProbability"
                    title="Current Probability (%)"
                    width="80px"
                    editable={false}
                    cell={(props) => (
                      <td>
                        <span className="turquoiseBlue">
                          {props.dataItem.currentProbability}
                        </span>
                      </td>
                    )}
                  />
                  <Column
                    field="reductionProbability"
                    title="Post-Probability (%)"
                    width="80px"
                    editable={false}
                    cell={(props) => (
                      <td>
                        <span className="yellowCell">
                          {props.dataItem.reductionProbability}
                        </span>
                      </td>
                    )}
                  />
                  <Column
                    field="pre"
                    title="pre"
                    width="75px"
                    sortable={false}
                    editable={false}
                    cell={(props) => (
                      <PrePostComponenant
                        {...props}
                        onEditCell={this.onEditCell}
                        HeatMapConfigDataOpportunity={
                          this.state.HeatMapConfigDataOpportunity
                        }
                        HeatMapConfigDataThreat={
                          this.state.HeatMapConfigDataThreat
                        }
                        dynamicHeatmapProbabilityRange={
                          this.state.dynamicHeatmapProbabilityRange
                        }
                      />
                    )}
                  />
                  <Column
                    field="current"
                    title="current"
                    width="75px"
                    sortable={false}
                    editable={false}
                    cell={(props) => (
                      <PrePostComponenant
                        {...props}
                        onEditCell={this.onEditCell}
                        HeatMapConfigDataOpportunity={
                          this.state.HeatMapConfigDataOpportunity
                        }
                        HeatMapConfigDataThreat={
                          this.state.HeatMapConfigDataThreat
                        }
                        dynamicHeatmapProbabilityRange={
                          this.state.dynamicHeatmapProbabilityRange
                        }
                      />
                    )}
                  />
                  <Column
                    field="post"
                    title="post"
                    width="75px"
                    editable={false}
                    sortable={false}
                    cell={(props) => (
                      <PrePostComponenant
                        {...props}
                        onEditCell={this.onEditCell}
                        HeatMapConfigDataOpportunity={
                          this.state.HeatMapConfigDataOpportunity
                        }
                        HeatMapConfigDataThreat={
                          this.state.HeatMapConfigDataThreat
                        }
                        dynamicHeatmapProbabilityRange={
                          this.state.dynamicHeatmapProbabilityRange
                        }
                      />
                    )}
                  />
                  {/* New  */}

                  <Column
                    field="preRiskScore"
                    title="Risk Score (Pre)"
                    width="80px"
                  />

                  {isPrime && (
                    <Column
                      field="preWeightedRiskScore"
                      title="Prime Risk Score (Pre)"
                      width="80px"
                    />
                  )}

                  <Column
                    field="currentRiskScore"
                    title="Risk Score (Current)"
                    width="80px"
                    cell={(props) => (
                      <td>
                        <span className="turquoiseBlue">
                          {props.dataItem.currentRiskScore}
                        </span>
                      </td>
                    )}
                  />

                  {isPrime && (
                    <Column
                      field="currentWeightedRiskScore"
                      title="Prime Risk Score (Current)"
                      width="80px"
                      cell={(props) => (
                        <td>
                          <span className="turquoiseBlue">
                            {props.dataItem.currentWeightedRiskScore}
                          </span>
                        </td>
                      )}
                    />
                  )}

                  <Column
                    field="postRiskScore"
                    title="Risk Score (Post)"
                    width="80px"
                    cell={(props) => (
                      <td>
                        <span className="yellowCell">
                          {props.dataItem.postRiskScore}
                        </span>
                      </td>
                    )}
                  />

                  {isPrime && (
                    <Column
                      field="postWeightedRiskScore"
                      title="Prime Risk Score (Post)"
                      width="80px"
                      cell={(props) => (
                        <td>
                          <span className="yellowCell">
                            {props.dataItem.postWeightedRiskScore}
                          </span>
                        </td>
                      )}
                    />
                  )}
                  {/* End  */}
                  {this.state.impactColumns}
                  <Column
                    field="impactComments"
                    title="Consequences"
                    width="120px"
                  />
                  <Column
                    field="progress"
                    title="Progress Status"
                    width="120px"
                    editable={false}
                    cell={(props) => (
                      <td title={props.dataItem.progress}>
                        <span>{props.dataItem.progress}</span>
                      </td>
                    )}
                  />
                  <Column
                    field="proximityDate"
                    title="Proximity Date"
                    width="120px"
                    format="{0:dd-MMM-yyyy}"
                  />
                  <Column field="owner" title="Owner" width="120px" />
                  <Column
                    field="riskFieldsCompletion"
                    title="% of fields completed"
                    width="120px"
                  />

                  <Column
                    field="createdDate"
                    title="Created Date"
                    filter={"date"}
                    format="{0:dd-MMM-yyyy}"
                    width="120px"
                  />
                  <Column
                    field="createdByName"
                    title="Created By"
                    width="120px"
                  />
                  <Column
                    field="updatedDate"
                    title="updated Date"
                    width="120px"
                    editor="date"
                    filter={"date"}
                    editable={false}
                    format="{0:dd-MMM-yyyy}"
                  />
                  <Column field="updatedBy" title="updated By" width="120px" />
                  <Column
                    field="isClosed"
                    title="Status"
                    width="80px"
                    cell={(props) => (
                      <StatusComponent
                        {...props}
                        onEditCell={this.onEditCell}
                      />
                    )}
                  />
                  <Column
                    field="closedDate"
                    title="closed Date"
                    width="120px"
                    format="{0:dd-MMM-yyyy}"
                  />
                </Grid>
              </div>
            </Window>
          )}

          {this.state.visibleDataset && (
            <Window
              title={chartData.dataSource}
              onClose={this.closeVisibleDataset}
              className="statusWindow"
              initialLeft={350}
              initialTop={200}
              initialWidth={1000}
              initialHeight={300}
            >
              <div className="tblCont dataGrids">
                <ViewActionRiskDataset
                  chartData={chartData}
                  isFreezeDS={this.props.isFreezeDS}
                ></ViewActionRiskDataset>
              </div>
            </Window>
          )}

          {this.props.expandIcon && (
            <div className="expandView">
              <a
                className="expand"
                onClick={() => this.changeLineChartWidth(chartData.widgetId)}
              >
                <img src={Images.VIEWFULLVIEW} alt="Expand" width="10" />
              </a>
              <a
                className="shrink"
                onClick={() => this.changeLineChartWidth(chartData.widgetId)}
              >
                <img src={Images.SHRINK} alt="Expand" width="10" />
              </a>
            </div>
          )}

          {this.props.viewDataSetIcon && (
            <ul className="viewDataset WidgetActions">
              <TextNarrative
                chartInputs={chartData}
                refreshTextNarative={this.refreshTextNarative}
                isFreezeDS={this.props.isFreezeDS}
              />
              <li
                title="View Dataset"
                onClick={() => this.ViewDataSet(chartData)}
              >
                <a>
                  <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
                </a>
              </li>
            </ul>
          )}

          {this.props.flag ? (
            <ul className="WidgetActions">
              {this.props.isTenentAdmin ||
                chartData.createdBy == userId ||
                (this.props.selectedDashboard &&
                  this.props.selectedDashboard.createdBy == userId)
                ? !this.props.isFreezeDS && (
                  <li onClick={() => this.editWidgetOpen(chartData)}>
                    <a>
                      <img src={Images.EDITICON} alt="Edit" width="14" />
                    </a>
                  </li>
                )
                : ""}
              <TextNarrative
                chartInputs={chartData}
                refreshTextNarative={this.refreshTextNarative}
                isFreezeDS={this.props.isFreezeDS}
              />
              <li
                title="View Dataset"
                onClick={() => this.ViewDataSet(chartData)}
              >
                <a>
                  <img src={Images.VIEWLIST} alt="View Dataset" width="14" />
                </a>
              </li>
              {this.props.isFreezeDS ? (
                ""
              ) : (
                <li
                  title="Add to home"
                  onClick={() => this.moveToHome(chartData)}
                >
                  <a>
                    <img src={Images.HOME} alt="Download" width="14" />
                  </a>
                </li>
              )}
              {/* {chartData.createdBy == userId && (
                <li onClick={() => this.editWidget(chartData)}>
                  <a>
                    <img src={Images.EDITICON} alt="Edit" width="14" />
                  </a>
                </li>
              )} */}
              <li title="PNG Download" onClick={this.onImageExportClick}>
                <a>
                  <img src={Images.DOWNLOAD} alt="Download" width="14" />
                </a>
              </li>
              <li title="PDF Download" onClick={this.onPDFExportClick}>
                <a>
                  <img src={Images.PDF} alt="Download" width="14" />
                </a>
              </li>
              {this.props.isFreezeDS ? (
                ""
              ) : (
                <li
                  title="Share"
                  onClick={() => this.openAddToCart(chartData.widgetId)}
                >
                  <a>
                    <img src={Images.SHARE} alt="Download" width="14" />
                  </a>
                </li>
              )}
              <li>
                <Dropdown
                  menuAlign="right"
                  title="Email"
                  id="dropdown-menu-align-right"
                >
                  <Dropdown.Toggle>
                    <a>
                      <img src={Images.EMAIL} alt="Share" width="14" />
                    </a>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="filterList emailBox">
                    <div className="filterBox">
                      <div className="dateRange">
                        <div className="dateCont">
                          <h6>Email</h6>
                          <input
                            type="email"
                            autoComplete="off"
                            value={this.state.emailId}
                            onChange={(e) =>
                              this.setState({
                                ...this.state,
                                emailId: e.target.value,
                              })
                            }
                          />
                        </div>
                        <div className="dateCont">
                          <h6>Message</h6>
                          <textarea
                            value={this.state.message}
                            autoComplete="off"
                            onChange={(e) =>
                              this.setState({
                                message: e.target.value,
                              })
                            }
                          ></textarea>
                          <Dropdown.Item
                            as="button"
                            onClick={() => this.onPDFExportClick("MAIL")}
                          >
                            SEND
                          </Dropdown.Item>
                        </div>
                      </div>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              </li>

              {this.props.isTenentAdmin ||
                chartData.createdBy == userId ||
                (this.props.selectedDashboard &&
                  this.props.selectedDashboard.createdBy == userId)
                ? !this.props.isFreezeDS && (
                  <li onClick={this.openWidgetDeletePopup}>
                    <a className="bgRed">
                      <img src={Images.TRASH} alt="Trash" width="13" />
                    </a>
                  </li>
                )
                : ""}
            </ul>
          ) : (
            <ul className="WidgetActions">
              {/* <li title="Remove from home" onClick={() => this.removeFromHome(chartData)}>
                <a>
                  <img src={Images.DELETEFROMHOME} alt="Download" width="14" />
                </a>
              </li> */}
            </ul>
          )}
          <div id={"c" + chartData.widgetId} className="heatmapHeader" key={chartData.title}>
            <div className="titleBG">
              {/* <span style={{display:'flex',paddingLeft:'8px',paddingTop:'10px',color:'white'}}>{this.state.widgettitle ?null:chartData.title}</span> */}
              {/* <small className="createdDate" style={{ paddingRight: "20px" }}>
                {CreatedDate}
              </small> */}
            </div>
            <div>
              <h5 className="heatmap_timestamp">
                <span></span>{chartData.title ? chartData.title : ""}
              </h5>
            </div>
            <div className="heatmapchart">
              <div className="heatmap1">
                <div className="hmOuterGrid ">
                  <div className="outerGridRow">
                    <div className="outerGridBox lLegendTitle">
                      <h5 style={{ whiteSpace: "nowrap" }}>Probability (%)</h5>
                    </div>
                    <div className="outerGridBox lLegendSubtitle">
                      <div className="lLegend">
                        {probabilityRange?.map((prob, i) => {
                          return (
                            <label
                              className="innerGridBox"
                              style={{ fontSize: "12px" }}
                            >
                              {prob.probabilityRangeValue}-
                              {i === 0
                                ? 100
                                : probabilityRange[i - 1]
                                  ?.probabilityRangeValue - 1}
                            </label>
                          );
                        })}
                      </div>
                    </div>
                    {/* Unmitigated-start */}
                    <div className="outerGridBox bLegendContainer">
                      <div className="innerGridCont">
                        {series1 &&
                          [...series1].reverse().map((item, index1) => (
                            <div className="innerGridRow">
                              {chartData.isOpportunities
                                ? item &&
                                item.data &&
                                [...item.data]
                                  .reverse()
                                  .map((cols, index2) => (
                                    <div
                                      className={"innerGridBox "}
                                      style={this.getBackgroundColor(
                                        index1,
                                        index2
                                      )}
                                      onClick={() =>
                                        this.toggleDialog(cols?.riskIds || [])
                                      }
                                    >
                                      {cols?.y || 0}
                                    </div>
                                  ))
                                : item &&
                                item.data &&
                                [...item.data].map((cols, index2) => (
                                  <div
                                    className={"innerGridBox "}
                                    style={this.getBackgroundColor(
                                      index1,
                                      index2
                                    )}
                                    onClick={() =>
                                      this.toggleDialog(cols?.riskIds || [])
                                    }
                                  >
                                    {cols?.y || 0}
                                  </div>
                                ))}
                            </div>
                          ))}
                        <div className=" y_axis">
                          {chartData.isOpportunities
                            ? probabilityRange.map((item) => {
                              return (
                                <div className="y_axis_abbrivation_heatmap">
                                  <label>
                                    {item?.abbreviation?.toUpperCase()}
                                  </label>
                                </div>
                              );
                            })
                            : dynamicHeatmapProbabilityRange?.map((item) => {
                              return (
                                <div className="y_axis_abbrivation_heatmap">
                                  <label>
                                    {item?.abbreviation?.toUpperCase()}
                                  </label>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                    {/* Unmitigated-End */}
                  </div>
                  <div className="outerGridRow">
                    <div className="outerGridBox lLegendTitle"></div>
                    <div className="outerGridBox lLegendSubtitle"></div>
                    <div className="outerGridBox bLegendContainer">
                      <div className="bLegend"></div>
                    </div>
                  </div>
                  <div className="outerGridRow">
                    <div className="outerGridBox lLegendTitle"></div>
                    <div className="outerGridBox lLegendSubtitle"></div>
                    <div
                      className="outerGridBox bLegendContainer"
                      style={{ paddingLeft: "60px", whiteSpace: "nowrap" }}
                    >
                      <h5>
                        {chartData.isOpportunities
                          ? "Impact - Unrealised"
                          : "Impact - Pre-Mitigated"}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="heatmap3">
                <div className="hmOuterGrid ">
                  <div className="outerGridRow">
                    <div className="outerGridBox lLegendTitle">
                      <h5 style={{ whiteSpace: "nowrap" }}>Probability (%)</h5>
                    </div>
                    <div className="outerGridBox lLegendSubtitle">
                      <div className="lLegend">
                        {probabilityRange?.map((prob, i) => {
                          return (
                            <label style={{ fontSize: "12px" }}>
                              {prob.probabilityRangeValue}-
                              {i === 0
                                ? 100
                                : probabilityRange[i - 1]
                                  ?.probabilityRangeValue - 1}
                            </label>
                          );
                        })}
                      </div>
                    </div>

                    {/* Current - start */}
                    <div className="outerGridBox bLegendContainer">
                      <div className="innerGridCont">
                        {series2 &&
                          [...series2].reverse().map((item, index1) => (
                            <div className="innerGridRow">
                              {chartData.isOpportunities
                                ? item &&
                                item.data &&
                                [...item.data]
                                  .reverse()
                                  .map((cols, index2) => (
                                    <div
                                      className={"innerGridBox "}
                                      style={this.getBackgroundColor(
                                        index1,
                                        index2
                                      )}
                                      onClick={() =>
                                        this.toggleDialog(cols?.riskIds || [])
                                      }
                                    >
                                      {cols?.y || 0}
                                    </div>
                                  ))
                                : item &&
                                item.data &&
                                [...item.data].map((cols, index2) => (
                                  <div
                                    className={"innerGridBox "}
                                    style={this.getBackgroundColor(
                                      index1,
                                      index2
                                    )}
                                    onClick={() =>
                                      this.toggleDialog(cols?.riskIds || [])
                                    }
                                  >
                                    {cols?.y || 0}
                                  </div>
                                ))}
                            </div>
                          ))}
                        <div className=" y_axis">
                          {chartData.isOpportunities
                            ? probabilityRange.map((item) => {
                              return (
                                <div className="y_axis_abbrivation_heatmap">
                                  <label>
                                    {item?.abbreviation?.toUpperCase()}
                                  </label>
                                </div>
                              );
                            })
                            : dynamicHeatmapProbabilityRange?.map((item) => {
                              return (
                                <div className="y_axis_abbrivation_heatmap">
                                  <label>
                                    {item?.abbreviation?.toUpperCase()}
                                  </label>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                    {/* {Current - End } */}
                  </div>
                  <div className="outerGridRow">
                    <div className="outerGridBox lLegendTitle"></div>
                    <div className="outerGridBox lLegendSubtitle"></div>
                    <div className="outerGridBox bLegendContainer">
                      <div className="bLegend"></div>
                    </div>
                  </div>
                  <div className="outerGridRow">
                    <div className="outerGridBox lLegendTitle"></div>
                    <div className="outerGridBox lLegendSubtitle"></div>
                    <div
                      className="outerGridBox bLegendContainer"
                      style={{ paddingLeft: "60px", whiteSpace: "nowrap" }}
                    >
                      <h5>{chartData.isOpportunities
                        ? "Impact - Current"
                        : "Impact - Current-Mitigated"}</h5>
                    </div>
                  </div>
                </div>
              </div>
              <div className="heatmap2">
                <div className="hmOuterGrid ">
                  <div className="outerGridRow">
                    <div className="outerGridBox lLegendTitle">
                      <h5 style={{ whiteSpace: "nowrap" }}>Probability (%)</h5>
                    </div>
                    <div className="outerGridBox lLegendSubtitle">
                      <div className="lLegend">
                        {probabilityRange?.map((prob, i) => {
                          return (
                            <label style={{ fontSize: "12px" }}>
                              {prob.probabilityRangeValue}-
                              {i === 0
                                ? 100
                                : probabilityRange[i - 1]
                                  ?.probabilityRangeValue - 1}
                            </label>
                          );
                        })}
                      </div>
                    </div>
                    {/* Mitigated-start */}
                    <div className="outerGridBox bLegendContainer">
                      <div className="innerGridCont">
                        {series &&
                          [...series].reverse().map((item, index1) => (
                            <div className="innerGridRow">
                              {chartData.isOpportunities
                                ? item &&
                                item.data &&
                                [...item.data]
                                  .reverse()
                                  .map((cols, index2) => (
                                    <div
                                      className={"innerGridBox "}
                                      style={this.getBackgroundColor(
                                        index1,
                                        index2
                                      )}
                                      onClick={() =>
                                        this.toggleDialog(cols?.riskIds || [])
                                      }
                                    >
                                      {cols?.y || 0}
                                    </div>
                                  ))
                                : item &&
                                item.data &&
                                [...item.data].map((cols, index2) => (
                                  <div
                                    className={"innerGridBox "}
                                    style={this.getBackgroundColor(
                                      index1,
                                      index2
                                    )}
                                    onClick={() =>
                                      this.toggleDialog(cols?.riskIds || [])
                                    }
                                  >
                                    {cols?.y || 0}
                                  </div>
                                ))}
                            </div>
                          ))}
                        <div className=" y_axis">
                          {chartData.isOpportunities
                            ? probabilityRange.map((item) => {
                              return (
                                <div className="y_axis_abbrivation_heatmap">
                                  <label>
                                    {item?.abbreviation?.toUpperCase()}
                                  </label>
                                </div>
                              );
                            })
                            : dynamicHeatmapProbabilityRange?.map((item) => {
                              return (
                                <div className="y_axis_abbrivation_heatmap">
                                  <label>
                                    {item?.abbreviation?.toUpperCase()}
                                  </label>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                    {/* Mitigated-End */}
                  </div>
                  <div className="outerGridRow">
                    <div className="outerGridBox lLegendTitle"></div>
                    <div className="outerGridBox lLegendSubtitle"></div>
                    <div className="outerGridBox bLegendContainer">
                      <div className="bLegend"></div>
                    </div>
                  </div>
                  <div className="outerGridRow">
                    <div className="outerGridBox lLegendTitle"></div>
                    <div className="outerGridBox lLegendSubtitle"></div>
                    <div
                      className="outerGridBox bLegendContainer"
                      style={{ paddingLeft: "60px", whiteSpace: "nowrap" }}
                    >
                      <h5>
                        {chartData.isOpportunities
                          ? "Impact - Realised"
                          : "Impact - Post-Mitigated"}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="wgHeader">
              &nbsp;&nbsp;&nbsp; <h4>Dataset: {chartData.dataSource} </h4>
            </div>
            <TextNarrativeExport chartData={chartData} isHidden={this.state.isHidden} />
            <ReportUpdate
              chartData={chartData}
              ref="childUpdateWidget"
              updateChartData={this.updateChartData}
            />
            {this.state.openPdfTitlePopup ||
              this.props.showTableFromDashboard ? (
              <div className="tblCont dataGrids">
                <ExportHeatmapViewActionRiskDataset
                  chartData={chartData}
                  isFreezeDS={this.props.isFreezeDS}
                ></ExportHeatmapViewActionRiskDataset>
                <br></br>
                <br></br>
              </div>
            ) : (
              ""
            )}
          </div>

          <Popup
            show={this.state.openDeleteModelFlag}
            popupClass={"popup-content"}
          >
            {this.state.loader ? (
              <span className="MatTableSpinner">
                <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
              </span>
            ) : null}
            <div className="deleteModelCont">
              <h3>Are you sure you want to delete this report?</h3>
              <div className="btnCont">
                <button
                  onClick={() => this.removeWidget(chartData)}
                  className="deleteBtn"
                  type="button"
                >
                  Yes
                </button>
                <button
                  onClick={this.closeWidgetDeletePopup}
                  className="cancelBtn"
                  type="button"
                >
                  No
                </button>
              </div>
            </div>
          </Popup>

          <Popup show={this.state.showAddToCart} popupClass={"popup-content"}>
            <AddToCart
              {...this.props}
              closeAddToCart={() => this.closeAddToCart()}
              cartViewDetailsId={this.state.cartViewDetails}
              cartViewType={this.state.cartViewType}
            />
          </Popup>

        </div>
      );
    }
  }
}
export default HeatMapChartContainer;
